import {FormControl, FormField} from 'platform/components';

import {FieldPathByValue, FieldValues} from 'react-hook-form';

import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {toSelectableModelFamilyOptions, VehicleMakeModelData} from 'features/vehicle-catalogue';

import {CustomCatalogueModel} from '../utils/groupUsageByMake';
import {KEEP_ORIGINAL_MODEL_FAMILY} from '../utils/remapMakeFormSchema';

type ModelFamilyMappingValues = {
  modelFamilyMapping: {modelFamily: string; targetModelFamily: string}[];
};

interface ModelFamilyMappingFieldsProps<TFieldValues extends FieldValues>
  extends RequiredTestIdProps {
  control: FormControl<TFieldValues>;
  models: CustomCatalogueModel[];
  modelCatalogue: VehicleMakeModelData | Nullish;
  isDisabled?: boolean;
  isLoading?: boolean;
}

/** One field per model, labelled with the model it replaces - no custom two-column layout. */
export function ModelFamilyMappingFields<
  TFieldValues extends FieldValues & ModelFamilyMappingValues,
>(props: ModelFamilyMappingFieldsProps<TFieldValues>) {
  const options = [
    {
      value: KEEP_ORIGINAL_MODEL_FAMILY,
      label: i18n.t('entity.customCatalogue.labels.keepOriginalModel'),
    },
    ...toSelectableModelFamilyOptions(props.modelCatalogue),
  ];

  return props.models.map((model, index) => (
    <FormField
      key={model.modelFamily}
      control={props.control}
      // Fixed by ModelFamilyMappingValues, which TS cannot see through the open generic.
      name={
        `modelFamilyMapping.${index}.targetModelFamily` as FieldPathByValue<TFieldValues, string>
      }
      type="choice"
      label={`${model.modelFamily} (${model.vehicleCount})`}
      options={options}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      isRequired
      isNotClearable
      menuInPortal
      data-testid={suffixTestId(`[${index}]-targetModelFamily`, props)}
    />
  ));
}
